import React from "react";

type FormInputProps = {
  label: string;
  name: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  type?: string;
  icon?: React.ReactNode;
  error?: string;
  readOnly?: boolean;
  maxLength?: number;
  className?: string;
  required?: boolean;
};

export const FormInput: React.FC<FormInputProps> = ({
  label,
  name,
  value,
  onChange,
  placeholder,
  type = "text",
  icon,
  error,
  readOnly = false,
  maxLength,
  className = "",
  required = false,
}) => {
  return (
    <div className={className}>
      <label
        htmlFor={name}
        className="block text-sm font-medium text-gray-700 mb-1"
      >
        {label} {required && <span className="text-red-500">*</span>}
      </label>
      <div className="relative">
        {icon && (
          <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
            {icon}
          </div>
        )}
        <input
          type={type}
          id={name}
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          readOnly={readOnly}
          maxLength={maxLength}
          className={`block w-full ${
            icon ? "pl-10" : "pl-3"
          } pr-3 py-2.5 border rounded-lg focus:ring-1 focus:ring-orange-500 focus:border-orange-500 text-gray-900 placeholder-gray-500 transition-colors ${
            error ? "border-red-500" : "border-gray-300"
          } ${readOnly ? "bg-gray-50 text-gray-600 cursor-not-allowed" : ""}`}
        />
      </div>
      {error && <p className="mt-1 text-sm text-red-600">{error}</p>}
    </div>
  );
};
